import { reduxWrapper } from "@common/redux/store";
import { PushkinCard } from "@kursk/components/pages/PushkinCard/PushkinCard";
import {
  loadRecommendationsForPushkinPlaces,
} from "@common/redux/slices/recommendation.slice";
import { loadTopPushkinEventsThunk } from "@common/redux/slices/picks";

export default function PushkinCardPage() {

  return <PushkinCard />;
}

export const getServerSideProps = reduxWrapper.getServerSideProps( async ({ store }) => {
  await Promise.all([
    store.dispatch(loadRecommendationsForPushkinPlaces({})),
    store.dispatch(loadTopPushkinEventsThunk({ complement: false, realm: 'culture' })),
  ]);
  return { props: {} };
})
